<h1 mat-dialog-title>
   User Preferences
    <button mat-icon-button class="close-icon" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <div mat-dialog-content class="custom-dialog-content">
    <form [formGroup]="preferencesForm" autocomplete="off">
            <div class="form-bgd">
                <!-- Dynamic Preferences Cards -->
                <div *ngFor="let pref of userPreferences" class="card" style="border: 1px solid #e0e0e0; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-bottom: 1.5rem;">
                    <div class="card-header" style="background: #fff; border-bottom: 1px solid #e0e0e0; padding: 1rem 1.5rem;">
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <i class="fa fa-camera" aria-hidden="true" style="color: #1a4d80;" *ngIf="isButtonTypePreference(pref.name)"></i>
                            <i class="fa fa-window-restore" aria-hidden="true" style="color: #1a4d80;" *ngIf="!isButtonTypePreference(pref.name)"></i>
                            <h6 class="mb-0" style="font-weight: 600; color: #1a4d80;">{{pref.name}}</h6>
                        </div>
                    </div>
                    <div class="card-body" style="padding: 1.5rem;">
                        <div class="d-flex align-items-start justify-content-between" style="gap: 2rem;">
                            <div style="flex: 1;">
                                <p style="font-size: 14px; color: #666; margin-bottom: 0;">{{pref.description}}</p>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" style="gap: 0.5rem;" *ngIf="isButtonTypePreference(pref.name)">
                                <div 
                                    class="view-mode-option" 
                                    [class.active]="pref.enabled"
                                    (click)="onPreferenceChange(pref.name, true)"
                                    style="padding: 8px 16px; border: 1px solid #e0e0e0; border-radius: 6px; cursor: pointer; transition: all 0.3s; background: #fff; display: flex; align-items: center; gap: 6px; font-size: 14px;"
                                    [style.border-color]="pref.enabled ? '#1a4d80' : '#e0e0e0'"
                                    [style.background]="pref.enabled ? '#1a4d80' : '#fff'"
                                    [style.color]="pref.enabled ? '#fff' : '#999'">
                                    <i class="fa fa-camera" aria-hidden="true" style="font-size: 14px;"></i>
                                    <span>Snapshot</span>
                                </div>
                                <div 
                                    class="view-mode-option" 
                                    [class.active]="!pref.enabled"
                                    (click)="onPreferenceChange(pref.name, false)"
                                    style="padding: 8px 16px; border: 1px solid #e0e0e0; border-radius: 6px; cursor: pointer; transition: all 0.3s; background: #fff; display: flex; align-items: center; gap: 6px; font-size: 14px;"
                                    [style.border-color]="!pref.enabled ? '#1a4d80' : '#e0e0e0'"
                                    [style.background]="!pref.enabled ? '#1a4d80' : '#fff'"
                                    [style.color]="!pref.enabled ? '#fff' : '#999'">
                                    <i class="fa fa-video-camera" aria-hidden="true" style="font-size: 14px;"></i>
                                    <span>Streaming</span>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" style="gap: 0.5rem;" *ngIf="!isButtonTypePreference(pref.name)">
                                <mat-slide-toggle 
                                    [formControlName]="preferenceFormControls[pref.name]"
                                    (change)="onPreferenceChange(pref.name, $event.checked)"
                                    color="primary">
                                    {{preferencesForm.get(preferenceFormControls[pref.name])?.value ? 'Enable' : 'Disable'}}
                                </mat-slide-toggle>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        <div class="text-center">
            <button  mat-stroked-button color="basic" class="back" (click)="onClose()">Cancel</button>
            <button class="select-btn" mat-raised-button (click)="savePreferences()">
                <i class="fa fa-floppy-o" aria-hidden="true"></i> Save Preferences
            </button>
          </div>
    
    </form>
</div>
